
import { SearchedArtwork } from '../typings';
import Vue, { PropType } from 'vue';
import CheckmarkFilled16 from '@carbon/icons-vue/es/checkmark--filled/16';

export default Vue.extend({
  components: {
    CheckmarkFilled16,
  },
  data() {
    return {
      isHovering: false,
    };
  },
  props: {
    item: {
      type: Object as PropType<SearchedArtwork>,
    },
    selectedItemId: {
      type: String,
      default: '',
    },
  },
  computed: {
    isSelectedItem() {
      return this.item.id.toString() === this.selectedItemId;
    },
  },
});
